import Vue from 'vue'
import Router from 'vue-router'
import test from '../page/test' 
import login from '../page/login'


import alipay from '../page/alipay'
import cart from '../page/Cart'
import goodsDetails from '../page/GoodsDetails'
import goodsList from '../page/GoodsList'
import invoiceDetails from '../page/InvoiceDetails'
import invoiceList from '../page/InvoiceList'
import orderConfirm from '../page/OrderConfirm'
import orderList from '../page/OrderList.vue'
import orderDetails from '../page/OrderDetails.vue'
import paySuccess from '../page/paySuccess.vue'
import statisticsDetails from '../page/statisticsDetails'
import statisticsList from '../page/StatisticsList'
import wxPay from '../page/wxPay'
Vue.use(Router)

const router = new Router({
  routes: [
      {
        path:"/",   // path 设置为 “/” ，默认显示该页面
        name:"/goodsList",
        component:goodsList
      },
      {
        path: '/login',
        name: 'login',
        component: login
      },
      {
        path: '/goodsList',
        name: 'goodsList',
        component: goodsList
      },
      {
        path: '/goodsDetails',
        name: 'goodsDetails',
        component: goodsDetails
      },
      {
        path: '/cart',
        name: 'cart',
        component: cart
      },
      {
        path: '/orderconfirm',
        name: 'orderConfirm',
        component: orderConfirm
      },
      {
        path: '/wxPay',
        name: 'wxPay',
        component: wxPay
      },
      {
        path: '/invoiceList',
        name: 'invoiceList',
        component:invoiceList
      },
      {
        path: '/invoiceDetails',
        name: 'invoiceDetails',
        component:invoiceDetails
      },
      {
        path: '/orderlist',
        name: 'orderList',
        component: orderList
      }
      ,{
        path: '/orderDetails',
        name: 'orderDetails',
        component: orderDetails
      }
      ,
      {
        path: '/alipay',
        name: 'alipay',
        component: alipay
      }
      ,
      {
        path: '/paySuccess',
        name: 'paySuccess',
        component: paySuccess
      }, {
        path: '/test',
        name: 'test',
        component: test
      }, {
        path: '/statisticsList',
        name: 'statisticsList',
        component: statisticsList
      }, {
        path: '/statisticsDetails',
        name: 'statisticsDetails',
        component: statisticsDetails
      }
    ]
});
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');
 
//     if (token === 'null' || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });
export default router;
  
  



// WEBPACK FOOTER //
// ./src/router/index.js